
import { h, Fragment } from 'preact'; /** @jsx h */
import { lazy } from 'preact-iso';

import { Module, Course } from '@pyqml/model';
import { ROUTES, timestampStringInEnglish } from '@pyqml/shared';

import { useCacheableQueryProvider } from "../app/CacheableQueryProvider";
import { useEnvironment } from "../app/Environment";

import { Layout } from '../components/Layout';
import { List } from '../components/List';
import { Subheader } from '../components/Subheader';
import { Cta } from "../components/Cta";


import { SubscribeSection } from '../glue/SubscribeSection';
import { BlogCover } from '../components/BlogCover';

//const RecommendedArticles = lazy(() => import('../glue/RecommendedArticles'));

//    {pages.map(page => <li><a href={`/${page.pageSlug}`}>{page.title}</a></li>)}


export const Algorithms = (props) => {
    
    const { cacheableQuery } = useCacheableQueryProvider();
    const { domain, subdomain, imageUrl, isDevelopment } = useEnvironment();
    

    // fetch the "teaser" modules
    const [result, refetch, count] = cacheableQuery?.({
        method: "POST",
        endpoint: ROUTES.CLOUDAPI_PUBLIC_LIST_PUBLISHED_COURSES,
        queryData: {
            subdomain: Module.MODULE_GROUP.ALGORITHM,
        },
        reloadOn: []
    });

    const courses = result?.data ?? undefined;

    //console.log("Algorithms", teaserCourse)


    //const featuredCategory = categories?.find?.(category => category.featured === true);
    //const pagesInFeaturedCategory = pages?.filter?.(page => page.category === featuredCategory?.category);

    //console.log("Algorithms", pages, pages?.[0]?.title)
    // , blog, categories, featuredCategory, pagesInFeaturedCategory^

    return <Layout.Stacked>

        {
            <Fragment as="Section">
                <BlogCover title="Algorithms" subtitle="List of all the available algorithms... more to come" />
                
            </Fragment>
        }

        <Layout.Section weight="equal">
            
        </Layout.Section>

        <Layout.Section weight="equal">
            
                <Subheader title="All Algorithms" />
                <div weight="top">
                    
                    <p>
                        On this page, you can find all the algorithms on quantum machine learning in the reverse chronological order.
                    </p>
                    {/*<p>
                    
                        
                        <Cta
                            size="full"
                            text={ "" }
                            ctaText={ "Start your QML journey now" }
                            ctaLink={ROUTES.BLOG_SUBSCRIBE}
                        />
                    
                    </p>*/}
                    <p>
                        <hr/>
                    </p>
                </div>

                <List.Standard>
                {
                    // sorted descending by revision
                    courses?.sort((a,b) => (b.orig_revision ? b.orig_revision : b.revision).localeCompare(a.orig_revision ? a.orig_revision : a.revision)).map((course: Course.ICourse) => (
                        <List.Item
                            title={ course.title }
                            abstract={ course.abstract }
                            image={ course.abstractImage ? `${imageUrl}/${course.abstractImage}` : undefined }
                            linkTo={ isDevelopment? `${ROUTES.BLOG_DRAFT}${ROUTES.BLOG_ALGORITHMS}/${course.slug}`: `${ROUTES.BLOG_ALGORITHMS}/${course.slug}` }
                            authorLinkTo="./frank"
                            authorName="Dr. Frank Zickert"
                            publishedAt={ timestampStringInEnglish(course.orig_revision ? course.orig_revision : course.revision) }
                            readingTime={ course.readingTime ?? undefined }
                        />
                    ))
                }
                    
                </List.Standard>
            
        </Layout.Section>

        {/*
        
            {
                /*teaserPage &&* / <Stage
                    title={/*teaserPage.title ?? ""* / "The Unprecedented Way To Learn Quantum Machine Learning"}
                    text={ /*teaserPage.abstract ?? "" * / "PyQML makes studying quantum machine learning an entertaining piece of cake you don't want to miss." }
                    ctaText={ /*teaserPage.teaser ?? "" * / "Get Started" }
                    ctaLink={ /*teaserPage.slug ?? "/" * / "/about" }
                    image={ /*teaserPage.abstractImage * / AlgorithmsImg}
                />
            }
        </Layout.Section>*/}

        <SubscribeSection as="Section"/>

        
    </Layout.Stacked>
            
}
  
